import React from 'react';
import {
  Edit,
  TabbedForm,
  FormTab,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  useTranslate,
  required,
  email,
} from 'react-admin';
import { Typography, Box } from '@mui/material';
import { MediaInput } from '../../components/inputs';

export const AboutEdit: React.FC = () => {
  const translate = useTranslate();

  return (
    <Edit>
      <TabbedForm>
        {/* Основная информация */}
        <FormTab label={translate('about.tabs.basic')}>
          <TextInput
            source="title"
            label={translate('about.fields.title')}
            validate={required()}
            fullWidth
            multiline
          />
          <TextInput
            source="titleDescription"
            label={translate('about.fields.titleDescription')}
            validate={required()}
            multiline
            rows={3}
            fullWidth
          />
        </FormTab>

        {/* Слайдер */}
        <FormTab label={translate('about.tabs.slider')}>
          <ArrayInput source="slider" label="">
            <SimpleFormIterator>
              <MediaInput
                source="imageId"
                label={translate('about.fields.sliderImage')}
                validate={required()}
              />
              <TextInput
                source="text"
                label={translate('about.fields.sliderText')}
                validate={required()}
                multiline
                rows={3}
                fullWidth
              />
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>

        {/* Список преимуществ */}
        <FormTab label={translate('about.tabs.advantages')}>
          <TextInput
            source="listTitle"
            label={translate('about.fields.listTitle')}
            validate={required()}
            fullWidth
            multiline
          />
          <TextInput
            source="listDescription"
            label={translate('about.fields.listDescription')}
            validate={required()}
            fullWidth
            multiline
          />

          <Box mt={3} width="100%">
            <Typography variant="h6" gutterBottom>
              {translate('about.fields.listItems')}
            </Typography>
            <ArrayInput source="listItems" label="" fullWidth>
              <SimpleFormIterator>
                <TextInput
                  source="title"
                  label={translate('about.fields.listItemTitle')}
                  validate={required()}
                  fullWidth
                  multiline
                />
                <TextInput
                  source="text"
                  label={translate('about.fields.listItemText')}
                  validate={required()}
                  multiline
                  rows={2}
                  fullWidth
                />
              </SimpleFormIterator>
            </ArrayInput>
          </Box>
        </FormTab>

        {/* Информационный блок */}
        <FormTab label={translate('about.tabs.info')}>
          <MediaInput
            source="infoImageId"
            label={translate('about.fields.infoImage')}
          />
          <TextInput
            source="infoTitle"
            label={translate('about.fields.infoTitle')}
            validate={required()}
            fullWidth
            multiline
          />
          <TextInput
            source="infoDescription"
            label={translate('about.fields.infoDescription')}
            validate={required()}
            multiline
            rows={3}
            fullWidth
          />
        </FormTab>

        {/* Контакты */}
        <FormTab label={translate('about.tabs.contacts')}>
          <TextInput
            source="phone"
            label={translate('about.fields.phone')}
            validate={required()}
            fullWidth
          />
          <TextInput
            source="email"
            label={translate('about.fields.email')}
            validate={[required(), email()]}
            type="email"
            fullWidth
          />
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};
